import platform from "platform";

const getDeviceInfo = () => ({
  origin: "web",
  browser: platform.name,
  brand: platform.manufacturer,
  userAgent: platform.ua,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  //   uniqueId: DeviceInfo.getUniqueID(),
  //   model: DeviceInfo.getModel(),
  //   deviceId: DeviceInfo.getDeviceId(),
  //   locale: DeviceInfo.getDeviceLocale(),
  //   country: DeviceInfo.getDeviceCountry()
});

export default getDeviceInfo;
